import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { WithChildrenProps } from '..';

interface PopupWrapperProps extends WithChildrenProps {
    show: boolean;
    disableBackdropClick?: boolean;
    disableEscapeKeyDown?: boolean;
    title?: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    fullWidth?: boolean;
    fullHeight?: boolean;
    dismiss?: () => any;
}

interface PopupWrapperState {

}

export class PopupWrapper extends React.Component<PopupWrapperProps, PopupWrapperState> {

    constructor(props: PopupWrapperProps) {
        super(props);
    }

    render() {
        const { show, title, disableBackdropClick, maxWidth, children, disableEscapeKeyDown, fullHeight, fullWidth, dismiss } = this.props;
        return (
            <Dialog
                open={!!show}
                aria-labelledby="responsive-dialog-title"
                onClose={(ev, reason) => {
                    if (reason === 'backdropClick' && disableBackdropClick === true) return;
                    if (dismiss) dismiss();
                }}
                maxWidth={maxWidth || false}
                fullWidth={fullWidth || false}
                disableEscapeKeyDown={disableEscapeKeyDown || false}
                PaperProps={{
                    style: {
                        overflowY: 'unset',
                        height: fullHeight === true ? '100%' : undefined
                    }
                }}
            >
                {title && <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>}
                <DialogContent style={{ overflowY: 'unset', display: 'flex', flexDirection: 'column', padding: 8 }}>
                    {show ? children : null}
                </DialogContent>
            </Dialog>
        );
    }

}